const StatementBox = ({ bgColor = "gray", children, stackText }) => {
  return (
    <div
      className={`mx-4 my-2 px-6 py-4 rounded-2xl text-left bg-${bgColor}-100 border-1 border-${bgColor}-400 text-${bgColor}-700 ${stackText && "flex flex-col"}`}
    >
      {children}
    </div>
  );
};

export default StatementBox;
